































import { Component, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import PlanSettingListResult from '@/components/plansetting/list/Result.vue';
import { formatApiError, compareString } from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';
import { AppModule } from '@/store/modules/app';
import { IPlanSummaryData, PlanSetting, BookingTypeEnum } from '@/api/types';
import {
  listPlans,
  IListPlansRequest,
  listPlanSettings,
  IListPlanSettingsRequest,
} from '@/api/tickets';
import { compileFunction } from 'vm';

@Component({
  name: 'PlanSettingList',
  components: {
    MaterialCard,
    PlanSettingListResult,
  },
})
export default class extends Vue {
  private plans: Map<string, IPlanSummaryData> = new Map();
  private planSettings: (PlanSetting & IPlanSummaryData)[] = [];
  private loading = true;
  private searched = false;

  get canDisplayResult() {
    return this.planSettings && this.planSettings.length > 0 && this.searched;
  }

  get canDisplayNoData() {
    return (
      (!this.planSettings || this.planSettings.length <= 0) && this.searched
    );
  }

  get noDataText() {
    return this.$t('No {msg}', {
      msg: (this.$t('Plan setting') as string).toLowerCase(),
    });
  }

  mounted() {
    this.fetchData();
  }

  private async fetchData() {
    AppModule.StartProgress();
    this.loading = true;
    await this.loadPlans();
    await this.loadPlanSettings();
    this.loading = false;
    AppModule.StopProgress();
  }

  private async loadPlans() {
    try {
      const res = await listPlans({} as IListPlansRequest);
      this.plans = new Map(res.plans.map(p => [p.planId, p]));
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Plan'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    this.searched = true;
  }

  private async loadPlanSettings() {
    try {
      const res = await listPlanSettings({} as IListPlanSettingsRequest);
      this.planSettings = res.plans
        .map(p => Object.assign(p, this.plans.get(p.planId)))
        .sort((a, b) =>
          compareString(a.activityTitle, b.activityTitle, () =>
            compareString(a.planTitle, b.planTitle, () =>
              compareString(
                b.bookingType || BookingTypeEnum.EACH_TIME,
                a.bookingType || BookingTypeEnum.EACH_TIME
              )
            )
          )
        );
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Plan setting'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    this.searched = true;
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
